import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width: "450px",
  }
}));

export const BootstrapDialogActions = styled(DialogActions)(() => ({
  border: "none !important",
  padding: "8px 21px 19px 16px !important",
}));

export const BootstrapDialogContent = styled(DialogContent)(() => ({
  border: "none !important",
}));

export const StyledDialogTitle = styled(DialogTitle)(() => ({
  border: "none !important",
  textTransform: "capitalize",
  width: "fit-content",
}))

